import React, { useState } from "react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HeroSection = () => {
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    user_courses: [],
  });

  const [showCourseOptions, setShowCourseOptions] = useState(false);

  const toggleCourseOptions = () => {
    setShowCourseOptions((prev) => !prev);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedCourses = checked
        ? [...prev.user_courses, value]
        : prev.user_courses.filter((course) => course !== value);
      return { ...prev, user_courses: updatedCourses };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { user_name, user_phone, user_courses } = formData;

    if (!user_name || !user_phone) {
      toast.error("Please fill in all the required fields.");
      return;
    }

    if (!/^\d{10}$/.test(user_phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    if (user_courses.length === 0) {
      toast.error("Please select at least one course.");
      return;
    }

    const templateParams = {
      user_name,
      user_phone,
      user_courses: user_courses.join(", "),
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success(
            "Thank you for registering! Our team will contact you soon."
          );
          setShowCourseOptions(false);
          setFormData({
            user_name: "",
            user_phone: "",
            user_courses: [],
          });
        },
        (error) => {
          toast.error("Failed to send email. Please try again.");
          console.error(error);
        }
      );
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-start pt-16">
      <img
        src={require("../assets/Bg1.webp")}
        alt="Visual"
        loading="lazy"
        className="w-full object-cover h-64 md:h-[500px] lg:h-[630px]"
      />

      <div className="w-full flex flex-col items-center justify-center bg-gradient-to-b from-black via-orange-500 to-black py-4">
        <h1 className="text-lg md:text-4xl lg:text-6xl mb-2 font-extrabold text-white text-center drop-shadow-md">
          Best in Class <br />
          <span className="text-yellow-300 block"> 3D Animation, VFX </span>
          <span className="text-yellow-300 block">
            Multimedia Training & Studio
          </span>
        </h1>

        <div className="w-[80%] md:w-full max-w-md bg-black/70 p-6 rounded-lg shadow-lg mt-6">
          <h2 className="text-yellow-400 text-lg mb-4 text-center leading-tight">
            Hey buddy! Fill the form for FREE counselling on VFX & 3D Animation
            courses!
          </h2>

          <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
            <input
              type="text"
              name="user_name"
              placeholder="NAME"
              value={formData.user_name}
              onChange={handleChange}
              className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
            />
            <input
              type="text"
              name="user_phone"
              placeholder="PHONE NUMBER"
              value={formData.user_phone}
              onChange={handleChange}
              className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
            />

            {/* Course Selector */}
            <div>
              <input
                type="text"
                name="course"
                readOnly
                onClick={toggleCourseOptions}
                value={formData.user_courses.join(", ")}
                placeholder="COURSE"
                className="w-full p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none cursor-pointer"
              />

              {showCourseOptions && (
                <div className="text-white space-y-2 mt-2">
                  {[
                    "3D Animation",
                    "VFX",
                    "Game Development",
                    "Video Editing",
                    "Motion Graphics",
                    "Graphics Design",
                    "UI/UX Design",
                  ].map((option, index) => {
                    const val = option.toLowerCase().replace(/\s+/g, "-");
                    return (
                      <label
                        key={index}
                        className="flex items-center space-x-2"
                      >
                        <input
                          type="checkbox"
                          value={val}
                          checked={formData.user_courses.includes(val)}
                          onChange={handleCheckboxChange}
                          className="accent-yellow-400"
                        />
                        <span>{option}</span>
                      </label>
                    );
                  })}
                </div>
              )}
            </div>

            <button
              type="submit"
              className="p-3 rounded bg-gradient-to-r from-yellow-400 to-yellow-200 font-bold text-black hover:from-yellow-300 hover:to-yellow-500"
            >
              REGISTER
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
